import React from 'react';
import CustomInput from '../../../../../../components/CustomInput';
import CustomSelect from '../../../../../../components/CustomSelect';

export default function EmailTypeDriverInputs({
    data,
    flag,
    onChange,
    onSelectChange,
    selectOptions,
}) {
    return (
        <>
            <div className="form__item-wrapper">
                <CustomSelect
                    labelText="Driver"
                    name={`email_driver_id_${flag}`}
                    onChange={(value) => onSelectChange(value, flag)}
                    value={data[flag]?.email_driver_id}
                    options={selectOptions}
                />
            </div>
            {!data[flag]?.email_driver_id && (
                <>
                    <div className="form__item-wrapper">
                        <CustomInput
                            id={`email_driver_host_${flag}`}
                            placeholder="Enter host name"
                            onInputChange={(e) => onChange(e, flag)}
                            inputValue={data[flag]?.email_driver_host}
                            labelText="Host"
                            width="100%"
                            //   errorText={errors?.name}
                        />
                    </div>
                    <div className="form__item-wrapper">
                        <CustomInput
                            id={`email_driver_username_${flag}`}
                            placeholder="Enter username"
                            onInputChange={(e) => onChange(e, flag)}
                            inputValue={data[flag]?.email_driver_username}
                            labelText="Username"
                            width="100%"
                            //   errorText={errors?.client_id}
                        />
                    </div>
                    <div className="form__item-wrapper">
                        <CustomInput
                            id={`email_driver_password_${flag}`}
                            placeholder="Enter city"
                            onInputChange={(e) => onChange(e, flag)}
                            inputValue={data[flag]?.email_driver_password}
                            labelText="Password"
                            width="100%"
                            //   errorText={errors?.name}
                        />
                    </div>
                </>
            )}
        </>
    );
}
